import React, { useRef, useEffect } from "react";
import { links, socialLinks } from "../../helpers/data.js";

import gsap from "gsap";

import "./Nav.scss";

const Nav = (props) => {
  const { isMenuOpen, menuToggle } = props;

  const socialIconsRef = useRef([]);
  socialIconsRef.current = [];
  const linksRef = useRef([]);
  linksRef.current = [];

  const addToSocialIconsRef = (el) => {
    socialIconsRef.current.push(el);
  };
  const addToLinksRef = (el) => {
    linksRef.current.push(el);
  };

  useEffect(() => {
    const tl = gsap.timeline({ paused: true });
    linksRef.current.forEach((link, i) => {
      tl.fromTo(
        link,
        {
          y: 100,
        },
        {
          duration: 0.5,
          ease: "power3.out",
          y: 0,
          delay: 0.8,
        },
        i * 0.1
      );
    });
    socialIconsRef.current.forEach((icon, i) => {
      tl.fromTo(
        icon,
        {
          y: 100,
        },
        {
          duration: 0.5,
          ease: "power3.out",
          y: 0,
          delay: 1.5,
        },
        i * 0.1
      );
    });

    isMenuOpen ? tl.play() : tl.reverse();

    return () => {
      tl.reverse();
    };
  }, [isMenuOpen]);

  return (
    <nav className={isMenuOpen ? "menu-open" : "navbar"}>
      <div className="navbar-wrapper">
        <div className="menu-wrapper">
          <ul className="menu-items">
            {links.map((link, i) =>
              Object.keys(link).map((path, index) => {
                return (
                  <li key={index} className="menu-item">
                    <a
                      className="link"
                      ref={addToLinksRef}
                      href={`#${link[path]}`}
                    >
                      <span data-link-alt={path} onClick={menuToggle}>
                        {path}
                      </span>
                    </a>
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </div>
      <ul className="social-links">
        {socialLinks.map(({ platform, link, logo }) => (
          <li key={platform} ref={addToSocialIconsRef} className="social-link">
            <a href={link} target="_blank" rel="noopener noreferrer">
              {logo}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Nav;
